/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMove = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M10.808 9.273h3.636V6.545h2.727L12.626 2 8.081 6.545h2.727zm-.91.909H7.172V7.455L2.626 12l4.545 4.546v-2.728H9.9zM22.627 12 18.08 7.455v2.727h-2.727v3.636h2.728v2.728zm-8.182 2.727h-3.636v2.727H8.08L12.626 22l4.545-4.546h-2.727z" /></svg>;
export default SvgMove;